export const uchebaName = 'Онлайн-школа Учёба.ру'

export const socialText = {
  title: 'Регистрация подтверждена',
  notStart: {
    description:
      'За день до мероприятия мы пришлём вам напоминание, а за 15 минут до начала - ссылку на подключение.',
    additionToDescription:
      '<br/>&nbsp;<br/>Выберите мессенджер, куда вам отправить Гид абитуриента',
  },
  started: {
    description:
      'Выберите мессенджер, куда вам отправить ссылку на подключение к трансляции',
  },
  finished: {
    description: 'Выберите мессенджер, куда вам отправить запись вебинара.',
  },
  forInstitutions: {
    description:
      'За день до мероприятия мы пришлем вам напоминание, а за 15 минут до начала - ссылку на подключение.<br/>&nbsp;<br/> Выберите мессенджер, куда вам отправить ссылку на подключение к трансляции',
  },
}
